import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { profileAPI } from '../api';
import LanguageSelector from '../components/LanguageSelector';
import LanguageFlag from '../components/LanguageFlag';
import axios from 'axios';
const secureApi=axios.create({baseURL:'/api'});
secureApi.interceptors.request.use(req=>{const t=localStorage.getItem('token');if(t)req.headers.Authorization='Bearer '+t;return req;});

export default function ProfilePage() {
  const { userId } = useParams();
  const { user } = useAuth();
  const isOwn = user?.id === userId;

  const [profile, setProfile] = useState(null);
  const [editing, setEditing] = useState(false);
  const [form, setForm] = useState({ display_name: '', bio: '', interests: '', intent: '', prompt1: '', prompt2: '', opening_move: '', timezone: '', avatar_url: '', visibility:'public', avatar_blurred:false });
  const [loading, setLoading] = useState(true);
  const [verification, setVerification] = useState(null);
  const [verifyMsg, setVerifyMsg] = useState('');
  const [safety, setSafety] = useState(null);
  const [safetyMsg, setSafetyMsg] = useState('');
  const [giftPanel, setGiftPanel] = useState(null);
  const [giftMsg, setGiftMsg] = useState('');
  const [giftSending, setGiftSending] = useState(false);
  const [receivedGifts, setReceivedGifts] = useState([]);

  useEffect(() => {
    profileAPI.get(userId).then((res) => {
      setProfile(res.data);
      setForm({
        display_name: res.data.display_name || '',
        bio: res.data.bio || '',
        interests: (res.data.interests || []).join(', '),
        timezone: res.data.timezone || '',
        avatar_url: res.data.avatar_url || '',
        intent: res.data.intent || '', prompt1: res.data.prompt1 || '', prompt2: res.data.prompt2 || '', opening_move: res.data.opening_move || '', visibility: res.data.visibility || 'public', avatar_blurred: !!res.data.avatar_blurred,
      });
      setLoading(false);
      if (new URLSearchParams(window.location.search).get('onboarding') === '1' && isOwn) setEditing(true);
    }).catch(() => setLoading(false));
  }, [userId]);

  useEffect(() => { if(isOwn) secureApi.get('/verification/status').then(r=>setVerification(r.data)).catch(()=>{}); }, [isOwn]);

  const requestVerification = async () => { setVerifyMsg(''); try { const r=await secureApi.post('/verification/photo'); setVerification(v=>({...v,status:r.data.request.status,request:r.data.request})); setVerifyMsg('审核申请已提交'); } catch(e){ setVerifyMsg(e.response?.data?.error||'提交失败'); } };

  useEffect(() => { if(!isOwn && user && userId) secureApi.get('/safety/status/'+userId).then(r=>setSafety(r.data)).catch(()=>{}); }, [isOwn, user, userId]);

  useEffect(() => {
    if (isOwn || !user || !userId) return;
    Promise.all([secureApi.get('/gifts'), secureApi.get('/revenue/coins')])
      .then(([giftRes, coinRes]) => setGiftPanel({ gifts: giftRes.data || [], balance: coinRes.data.balance || 0 }))
      .catch(() => {});
  }, [isOwn, user, userId]);

  useEffect(() => {
    if (!isOwn) return;
    secureApi.get('/revenue/gifts/received').then(r => setReceivedGifts(r.data || [])).catch(() => {});
  }, [isOwn]);

  const giftMeta = giftId => ({rose:['🌹','玫瑰'],diamond:['💎','钻石'],crown:['👑','皇冠']})[giftId] || ['🎁','礼物'];

  const sendGift = async (gift) => {
    setGiftMsg('');
    setGiftSending(true);
    try {
      const giftKey = String(gift.id || '').replace(/^gift_/, '');
      const result = await secureApi.post('/revenue/gifts/send', { giftId: giftKey, recipientId: userId });
      setGiftPanel(current => ({ ...current, balance: result.data.balance }));
      setGiftMsg('礼物已送出，对方会在收礼记录中看到。');
    } catch (e) {
      setGiftMsg(e.response?.status === 402 ? 'Heart Coins 不足，请先充值。' : (e.response?.data?.error || '赠礼失败，请稍后重试'));
    } finally {
      setGiftSending(false);
    }
  };

  const safetyAction = async (kind) => {
    setSafetyMsg('');
    try {
      if (kind === 'report') { const details = window.prompt('请描述问题（可选）',''); if (details === null) return; await secureApi.post('/safety/report',{targetUserId:userId,category:'user_report',details}); setSafetyMsg('举报已提交，我们会尽快审核'); return; }
      if (kind === 'block') { if (!window.confirm('拉黑后将无法继续联系，确定吗？')) return; await secureApi.post('/safety/block',{targetUserId:userId}); setSafety({blocked:true,blockedByMe:true}); setSafetyMsg('已拉黑该用户'); return; }
      if (kind === 'unmatch') { if (!window.confirm('确定取消匹配并结束联系吗？')) return; await secureApi.post('/safety/unmatch',{targetUserId:userId}); setSafetyMsg('已取消匹配'); return; }
    } catch(e) { setSafetyMsg(e.response?.data?.error || '操作失败，请稍后重试'); }
  };

  const saveProfile = async () => {
    try {
      const data = { ...form, interests: form.interests.split(',').map(s => s.trim()).filter(Boolean) };
      const res = await profileAPI.update(userId, data);
      setProfile(res.data);
      setEditing(false);
    } catch { alert('保存失败'); }
  };

  const update = (k, v) => setForm(f => ({ ...f, [k]: v }));

  if (loading) return <div className="page-center"><p style={{ color: 'var(--text-dim)' }}>加载中...</p></div>;
  if (!profile) return <div className="page-center"><p style={{ color: 'var(--text-dim)' }}>用户不存在</p></div>;

  if (editing) {
    return (
      <div className="page-center">
        <div className="card form-card">
          <h2>✏️ 编辑资料</h2>
          <div className="field">
            <label>昵称</label>
            <input value={form.display_name} onChange={(e) => update('display_name', e.target.value)} />
          </div>
          <div className="field">
            <label>个人简介</label>
            <textarea value={form.bio} onChange={(e) => update('bio', e.target.value)} rows={3} placeholder="介绍一下自己..." />
          </div>
          <div className="field"><label>我正在寻找</label><select value={form.intent} onChange={(e)=>update('intent',e.target.value)}><option value="">选择关系目标</option><option value="serious">认真恋爱</option><option value="companionship">情感陪伴</option><option value="language">语言与文化交流</option><option value="friendship">先从朋友开始</option></select></div>
          <div className="field"><label>关于我的一个问题</label><input value={form.prompt1} onChange={(e)=>update('prompt1',e.target.value)} placeholder="例如：理想的周末是什么样？" /></div>
          <div className="field"><label>我希望对方知道</label><input value={form.prompt2} onChange={(e)=>update('prompt2',e.target.value)} placeholder="写一句真实的自我介绍" /></div>
          <div className="field"><label>匹配后的开场问题</label><input value={form.opening_move} maxLength={140} onChange={(e)=>update('opening_move',e.target.value)} placeholder="例如：如果现在能去任何地方旅行，你会选哪里？" /><small style={{color:'var(--text-dim)'}}>匹配后显示在聊天顶部，帮助对方自然开启话题。{form.opening_move.length}/140</small></div>
          <div className="field"><label>资料可见范围</label><select value={form.visibility} onChange={(e)=>update('visibility',e.target.value)}><option value="public">公开：可被发现</option><option value="hidden">隐藏：仅自己可见</option></select></div>
          <div className="field"><label style={{display:'flex',gap:8,alignItems:'center'}}><input type="checkbox" checked={form.avatar_blurred} onChange={(e)=>update('avatar_blurred',e.target.checked)} /> 对非匹配用户模糊头像</label></div>
          <div className="field">
            <label>兴趣 (逗号分隔)</label>
            <input value={form.interests} onChange={(e) => update('interests', e.target.value)} placeholder="音乐, 旅行, 美食" />
          </div>
          <div className="btn-group">
            <button className="btn btn-primary" onClick={saveProfile}>保存</button>
            <button className="btn btn-secondary" onClick={() => setEditing(false)}>取消</button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="page-center">
      <div className="profile-card">
        <div className="profile-avatar">
          <div className="avatar-placeholder big">
            {profile.display_name?.charAt(0)?.toUpperCase() || '?'}
          </div>
        </div>
        <h2>{profile.display_name || profile.username}</h2>
        <p className="profile-bio">{profile.bio || '这个人很懒，什么都没写~'}</p>
        {profile.intent && <span className="tag" style={{display:'inline-block',marginBottom:10}}>🎯 {({serious:'认真恋爱',companionship:'情感陪伴',language:'语言与文化交流',friendship:'先从朋友开始'})[profile.intent] || profile.intent}</span>}
        {(profile.prompt1 || profile.prompt2) && <div style={{textAlign:'left',margin:'10px 0',padding:'12px',borderRadius:12,background:'var(--glass)'}}>{profile.prompt1 && <p style={{margin:'0 0 8px'}}><strong>问我：</strong>{profile.prompt1}</p>}{profile.prompt2 && <p style={{margin:0}}><strong>关于我：</strong>{profile.prompt2}</p>}</div>}
        {profile.opening_move && <div style={{textAlign:'left',margin:'10px 0',padding:'12px',borderRadius:12,background:'rgba(236,72,153,.09)',border:'1px solid rgba(236,72,153,.22)'}}><strong>💬 匹配后聊这个</strong><p style={{margin:'6px 0 0'}}>{profile.opening_move}</p></div>}
        <div className="profile-tags">
          <span className="tag">🌍 {profile.country_code}</span>
          <LanguageFlag code={profile.preferred_language} size={20} showName />
          {(profile.interests || []).map((i) => <span key={i} className="tag">#{i}</span>)}
        </div>
        {profile.photo_verified && <span className="tag" style={{display:'inline-block',marginBottom:10,color:'#4ade80'}}>✅ 照片已审核</span>}
        {isOwn && verification && <div style={{margin:'12px 0',padding:12,borderRadius:12,background:'var(--glass)',textAlign:'left'}}><strong>🛡️ 真人照片审核</strong><p style={{fontSize:'0.8rem',color:'var(--text-dim)',margin:'6px 0'}}>{verification.photoVerified?'已通过审核':verification.status==='pending'?'审核中，通常需要人工确认':'上传头像后申请审核，审核通过才会显示认证标记。'}</p>{!verification.photoVerified && verification.status!=='pending' && <button className="btn btn-secondary" onClick={requestVerification}>申请照片审核</button>}{verifyMsg && <div style={{fontSize:'0.78rem',marginTop:6}}>{verifyMsg}</div>}</div>}
        {!isOwn && user && giftPanel && <div style={{margin:'16px 0 4px',padding:12,borderRadius:12,background:'var(--glass)',textAlign:'left'}}>
          <div style={{display:'flex',justifyContent:'space-between',gap:10,alignItems:'center'}}><strong>💝 送一份心意</strong><span className="tag">余额 {giftPanel.balance} Coins</span></div>
          <div style={{display:'grid',gridTemplateColumns:'repeat(3,minmax(0,1fr))',gap:8,marginTop:10}}>
            {giftPanel.gifts.map((gift, index) => { const meta=[['🌹','玫瑰'],['💎','钻石'],['👑','皇冠']][index] || ['🎁','礼物']; return <button key={gift.id} className="btn btn-secondary" disabled={giftSending} onClick={()=>sendGift(gift)} style={{padding:'9px 4px',fontSize:'.76rem'}}><span style={{display:'block',fontSize:'1.35rem'}}>{meta[0]}</span>{meta[1]} · {gift.price}</button>; })}
          </div>
          <div style={{fontSize:'.75rem',color:'var(--text-dim)',marginTop:8}}>赠礼会直接扣除 Heart Coins。<a href="/pricing" style={{marginLeft:4}}>充值</a></div>
          {giftMsg && <div style={{fontSize:'.78rem',marginTop:8,color:'var(--text-dim)'}}>{giftMsg}</div>}
        </div>}
        {!isOwn && user && safety && <div style={{margin:'16px 0 4px',padding:12,borderRadius:12,background:'var(--glass)',textAlign:'left'}}><strong>🛡️ 安全操作</strong><div style={{display:'flex',gap:8,flexWrap:'wrap',marginTop:8}}>{safety.blockedByMe ? <span className='tag'>已拉黑</span> : <button className='btn btn-secondary' onClick={()=>safetyAction('block')}>拉黑</button>}<button className='btn btn-secondary' onClick={()=>safetyAction('unmatch')}>取消匹配</button><button className='btn btn-secondary' onClick={()=>safetyAction('report')}>举报</button></div>{safetyMsg && <div style={{fontSize:'.78rem',marginTop:8,color:'var(--text-dim)'}}>{safetyMsg}</div>}</div>}
        {isOwn && (
          <button className="btn btn-primary" onClick={() => setEditing(true)}>
            ✏️ 编辑资料
          </button>
        )}
      </div>
      {isOwn && receivedGifts.length > 0 && <div className="card" style={{marginTop:20,width:'100%',maxWidth:400,textAlign:'left'}}>
        <h3 style={{margin:'0 0 10px'}}>💝 最近收到的礼物</h3>
        <div style={{display:'flex',flexDirection:'column',gap:8}}>
          {receivedGifts.slice(0,10).map(gift => { const meta=giftMeta(gift.giftId); return <a key={gift.id} href={'/profile/'+gift.fromUserId} style={{display:'flex',alignItems:'center',gap:10,padding:10,borderRadius:10,background:'var(--glass)',color:'inherit',textDecoration:'none'}}><span style={{fontSize:'1.5rem'}}>{meta[0]}</span><span style={{flex:1}}><strong>{gift.fromDisplayName}</strong><span style={{display:'block',fontSize:'.76rem',color:'var(--text-dim)'}}>送给你一份{meta[1]} · {new Date(gift.createdAt).toLocaleDateString()}</span></span></a>; })}
        </div>
      </div>}
      {isOwn && (
        <div className='profile-options' style={{marginTop:20,width:'100%',maxWidth:400}}>
          <h3 style={{marginBottom:10}}>⚙️ 账号设置</h3>
          <div style={{display:'flex',flexDirection:'column',gap:8}}>
            <a href='/pricing' className='btn btn-secondary' style={{textAlign:'center',textDecoration:'none'}}>💎 会员管理</a>
            <a href='/marketplace/orders' className='btn btn-secondary' style={{textAlign:'center',textDecoration:'none'}}>📦 我的订单</a>
            <a href='/shop' className='btn btn-secondary' style={{textAlign:'center',textDecoration:'none'}}>🏪 我的店铺</a>
          </div>
        </div>
      )}
    </div>
  );
}
